import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getMyBookings, selectMyBookings } from '../../../reducers/Organisation/reservationsReducer'
import { selectUserData } from '../../../reducers/userDataReducer'

import BookingBox from './BookingBox'
import BookingDetailsSidebar from './BookingDetailsSidebar'

const ClientReservationsMyBookings = ({ getMyBookings, myBookings, userData }) => {
  const { t } = useTranslation(['client-reservations'])
  const timezone = userData.buildingId.timezone
  const [selectedBooking, setSelectedBooking] = useState(null)

  useEffect(() => {
    fetchMyBookings()
  }, [])

  const fetchMyBookings = async () => {
    try {
      await getMyBookings()
    } catch ({ message }) {
      console.error(message)
    }
  }

  return (
    <div className="client-reservations-container">
      <div className="client-reservations-my-bookings">
        {myBookings.length ? (
          myBookings.map((booking) => (
            <BookingBox
              key={booking.id}
              booking={booking}
              timezone={timezone}
              selectedBooking={selectedBooking}
              onClick={(selected) => setSelectedBooking(selected)}
            />
          ))
        ) : (
          <div>{t('client-reservations:myBookings.noneFound')}</div>
        )}
      </div>
      {selectedBooking ? (
        <BookingDetailsSidebar bookingData={selectedBooking} timezone={timezone} />
      ) : null}
    </div>
  )
}

ClientReservationsMyBookings.propTypes = {
  myBookings: PropTypes.array,
  getMyBookings: PropTypes.func,
  userData: PropTypes.object,
}

export default connect(
  (state) => ({
    myBookings: selectMyBookings(state),
    userData: selectUserData(state),
  }),
  { getMyBookings },
)(ClientReservationsMyBookings)
